import type Tracker from "@openreplay/tracker";
import trackerVuex from "@openreplay/tracker-vuex";
import type { PiniaPluginContext } from "pinia";

export interface OpenReplayPiniaOptions {
  [key: string]: any;
}

// Wire OpenReplay's official Pinia/Vuex plugin so OpenReplay can auto-detect it
export function createOpenReplayPiniaPlugin(
  tracker: Tracker,
  options?: OpenReplayPiniaOptions
) {
  console.log('🏭 OpenReplay: Creating Pinia plugin factory');
  // Create OpenReplay's plugin factory (must be done before tracker.start())
  const vuexPluginFactory = tracker.use(trackerVuex(options as any));
  console.log('🏭 OpenReplay: Vuex plugin factory created:', !!vuexPluginFactory);

  // Attach to each Pinia store upon creation
  return function openReplayPiniaPlugin(context: PiniaPluginContext) {
    const { store } = context;
    console.log('🏪 OpenReplay: Registering store:', store.$id);
    try {
      const piniaStorePlugin = vuexPluginFactory(store.$id);
      console.log('🏪 OpenReplay: Store plugin created for:', store.$id);
      // Cast to any to satisfy types since the plugin supports Pinia stores at runtime
      piniaStorePlugin(store as any);
      console.log('✅ OpenReplay: Store plugin attached to:', store.$id);
    } catch (error) {
      console.error('❌ OpenReplay: Failed to attach plugin to store:', store.$id, error);
    }
  };
}

export default createOpenReplayPiniaPlugin;


